import getCombatantLastRoundAction from './getCombatantLastRoundAction'

function countUnusedReactions(combatant, maxCR) {
  let unusedReactionCount = 0

  for (let reactionNum = 1; reactionNum <= maxCR; reactionNum++) {
    if (combatant[`cr_name${reactionNum}`] === 'pending') {
      unusedReactionCount++
    }
  }

  return unusedReactionCount
}

export default function getCombatantExtraAttackInvalidReason({
  combatant,
  maxCA,
  maxCR,
  nextAction = null,
  onCounters = false,
}) {
  console.log('IN getCombatantExtraAttackInvalidReason combatant = ', combatant.name, ' details: ', combatant)

  // determine if extra action already taken
  let extra_action_taken = combatant.ca_type5 !== ''
  console.log('extra_action_taken = ', extra_action_taken)
  console.log('combatant.ca_type5 = ', combatant.ca_type5)

  if (countUnusedReactions(combatant, maxCR) < 1) {
    return 'No unused reactions'
  }

  if (!combatant?.shield && !combatant?.second_weapon) {
    return 'No Shield/\nSecond Weapon'
  }

  if (nextAction) {
    return 'Action in progress'
  }

  // if combatant is on counters (in next round) and has not taken an extra action yet - they cannot take an extra action
  if (onCounters && !extra_action_taken) {
    return 'On counters'
  }

  const lastAction = getCombatantLastRoundAction(combatant, maxCA)

  if (!lastAction.action?.eligible_extra_attack_last_action) {
    return 'Ineligible last action'
  }

  return ''
}
